import { atom } from "recoil"

export const favoriteMatchingOffersRequestIdState = atom({
  key: "atoms/matching/favoriteMatchingOffersRequestIdState",
  default: 0,
})
